import { ComboBox, TextInput } from '@components';
import { dependenteSchema } from '@schemas';
import { Field, Form, Formik } from 'formik';
import React, { useState } from 'react';

export const Dependente = ({ dependente, index, onChangeDependente }) => {
  const [exibirDetalhes, setExibirDetalhes] = useState(false);

  const initialValues = {
    nome: dependente.nome,
    cpf: dependente.cpf,
    dataNascimento: dependente.dataNascimento,
    parentesco: dependente.parentesco,
    sexo: dependente.sexo,
    nomeMae: dependente.nomeMae,
    nomePai: dependente.nomePai,
    isEstudante: dependente.isEstudante,
    isInvalido: dependente.isInvalido,
  };

  const onChangeForm = (formValues) => {
    onChangeDependente(formValues, index);
  };

  const handleVerMaisClick = () => {
    setExibirDetalhes((prev) => !prev);
  };

  return (
    <div className="card mb-32">
      <p className="mb-32 text-muted ts-14">
        Dependentes legais para imposto de renda
      </p>
      <h1 className="fw-bold ts-24 mb-4">Dependente {index + 1}</h1>
      <Formik
        initialValues={initialValues}
        validationSchema={dependenteSchema}
        validate={onChangeForm}
      >
        {() => (
          <Form>
            <div className="row">
              <Field
                className="mb-6"
                name="nome"
                component={TextInput}
                label="Nome completo"
                disabled
              />
              {exibirDetalhes && (
                <>
                  <div className="col-md-12 col-lg-6">
                    <Field
                      className="mb-3"
                      name="cpf"
                      component={TextInput}
                      label="CPF"
                      disabled
                    />
                    <Field
                      className="mb-3"
                      name="sexo"
                      component={ComboBox}
                      label="Sexo"
                      options={['Masculino', 'Feminino', 'Outros'].map((s) => {
                        return { value: s, label: s };
                      })}
                      disabled
                    />
                    <Field
                      className="mb-3"
                      name="isEstudante"
                      component={TextInput}
                      label="É estudante?"
                      disabled
                    />
                  </div>
                  <div className="col-md-12 col-lg-6">
                    <Field
                      className="mb-3"
                      name="dataNascimento"
                      component={TextInput}
                      label="Nascimento"
                      disabled
                    />

                    <Field
                      className="mb-3"
                      name="parentesco"
                      component={TextInput}
                      label="Parentesco"
                      disabled
                    />
                    <Field
                      className="mb-3"
                      name="isInvalido"
                      component={TextInput}
                      label="É inválido?"
                      disabled
                    />
                  </div>
                </>
              )}
            </div>
            <div className="text-center my-3">
              <button
                type="button"
                className="btn btn-primary white"
                onClick={handleVerMaisClick}
              >
                {exibirDetalhes ? 'Ver Menos' : 'Ver Mais'}
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};
